<template>
    <div class="container" v-if="!exists">
      <div class="container-tra">
          
        <div class="msg-order">
          <div v-if="mobile">
            <img src="/static/img/noencontrado.png" class="img-nf" />
          </div>        
          <div>
            <div class="title-nf">
              No hemos podido encontrar tu pedido
            </div>
            <p class="p-nf">
              Comunicate con nosotros para brindarte información de tu pedido
            </p>
            <br/>
            <button v-on:click="contact()" class="btn btn-ora" style="width:200px">Contáctate con nosotros</button>
          </div>
          <div v-if="!mobile">
            <img src="/static/img/noencontrado.png" class="img-nf" />
          </div>
        </div>   
      </div>      
  </div>  
</template>
<script>
import constants from 'assets/js/constants.js'

export default {
  name: 'Tracking',
  data () {
    return {
      parameter: '',
      mobile: false,
      exists: false
    }
  },
  created () {
    this.mobile = this.isMobile()
    this.parameter = this.$route.params.id
    this.name = this.$route.params.name === undefined ? '' : this.$route.params.name
    this.exists = false
    if (this.parameter !== undefined) {
      this.exists = true
      let isTracking = false
      if (this.parameter.length === 20) {
        let id = this.parameter.substring(0, 5)
        let letter = id.substring(0, 1)
        let number = id.substring(1, 5)

        let isNumber = false
        if (/^[0-9]+$/.test(number)) {
          isNumber = true
        }

        let isLetter = false
        if (/^[A-Z]+$/.test(letter)) {
          isLetter = true
        }

        if ((isLetter && isNumber) || id === '90001') { isTracking = true }
      }

      if (isTracking) {
        this.$router.push({ name: 'TrackingNumber', params: { tracking: this.parameter, name: this.name } })
      } else {
        this.$router.push({ name: 'TrackingOrder', params: { order: this.parameter, name: this.name } })
      }
    }
  },
  methods: {
    isMobile () {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    },
    contact () {
      window.open(constants.defaultGeneral.urlHelp, '_blank')
    }
  }
}
</script>
<style>
  .container-tra {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #f9f6f6;
    top: 0;
    left: 0;
    font-family : "Poppins"
  }

  .msg-order
  {
    margin: 20px;
    background-color: white;
    justify-content: space-evenly;
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #DBDFE3;
  }  

  .img-nf
  {
    max-width:400px;
  }

  .title-nf
  {
    color: #FF7800;
    font-size: 24px;
    font-weight: 900;
    margin-top: 20px;
  } 
  
  .p-nf
  {
    padding-top: 20px;
  }

  .btn-ora
  {
    height: 36px;
    color:#ffffff;
    background-color: #FF833E;
    width:100%;
    border-radius: 8px;
  }

  .btn-ora:hover
  {
    background-color: #fb5d05;
    color:#ffffff;
  } 
  
  .btn-ora:active
  {
    background-color: #fb5d05;
    color:#ffffff !important;
  }   

  @media screen and (max-width: 414px) {
    .row {
      margin-right: 0px !important;
    }

    .msg-order {    
      display: block;    
      text-align:center;
    }  

    .img-nf
    {
      max-width:250px;
    }  
  }

  @media screen and (max-width: 320px) {
    .row {
      margin-right: 0px !important;
    }
    
    .msg-order {    
      display: block;    
      text-align:center;
    }  

    .img-nf
    {
      max-width:250px;
    }     
  }
  
</style>



// WEBPACK FOOTER //
// Tracking.vue?6ad1329a